import { render, staticRenderFns } from "./AcctPeriodHelpList.vue?vue&type=template&id=1960a39c&"
import script from "./AcctPeriodHelpList.vue?vue&type=script&lang=js&"
export * from "./AcctPeriodHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports